import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api/axios';
import { useAuth } from '../../context/AuthContext';

const CM = {
  pending:     { bg: 'linear-gradient(135deg,#f59e0b,#fbbf24)', icon: '⏳', shadow: 'rgba(245,158,11,0.35)' },
  approved:    { bg: 'linear-gradient(135deg,#0d1a6e,#4f6ef7)', icon: '✓',  shadow: 'rgba(79,110,247,0.35)' },
  rejected:    { bg: 'linear-gradient(135deg,#dc2626,#ef4444)', icon: '✕',  shadow: 'rgba(220,38,38,0.35)' },
  in_progress: { bg: 'linear-gradient(135deg,#ea580c,#f97316)', icon: '⚙',  shadow: 'rgba(234,88,12,0.35)' },
  completed:   { bg: 'linear-gradient(135deg,#7c3aed,#a78bfa)', icon: '★',  shadow: 'rgba(124,58,237,0.35)' },
};

const statusLink = {
  pending: '/user/my-requests',
  approved: '/user/my-requests',
  rejected: '/user/my-requests',
  in_progress: '/user/my-requests',
  completed: '/user/my-requests',
};

const StatCard = ({ label, value, status }) => {
  const c = CM[status] || { bg: 'linear-gradient(135deg,#64748b,#94a3b8)', icon: '•', shadow: 'rgba(0,0,0,0.2)' };
  return (
    <Link to={statusLink[status] || '/user/my-requests'} style={{ ...S.statCard, background: c.bg, boxShadow: `0 8px 24px ${c.shadow}`, textDecoration: 'none' }}>
      <div style={S.statIconWrap}>{c.icon}</div>
      <div style={S.statValue}>{value}</div>
      <div style={S.statLabel}>{label}</div>
      <div style={S.statArrow}>→</div>
    </Link>
  );
};

const STATUSES = ['pending', 'approved', 'rejected', 'in_progress', 'completed'];

const UserDashboard = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState([]);
  useEffect(() => { api.get('/requests/stats').then(r => setStats(r.data)); }, []);

  const getCount = (status) => {
    const found = stats.find(s => s.status === status);
    return found ? Number(found.count) : 0;
  };

  return (
    <div>
      {/* Welcome banner */}
      <div style={S.banner}>
        <div style={S.bannerBg} />
        <div style={{ position: 'relative', zIndex: 1 }}>
          <div style={S.bannerGreet}>Good day, {user.name}! 👋</div>
          <div style={S.bannerSub}>Here's an overview of your master data requests</div>
        </div>
        <div style={S.bannerBlob1} />
        <div style={S.bannerBlob2} />
      </div>

      {/* Stats */}
      <div style={S.statsRow}>
        {STATUSES.map(status => (
          <StatCard key={status} label={status.replace('_', ' ').toUpperCase()} value={getCount(status)} status={status} />
        ))}
      </div>

    </div>
  );
};

const S = {
  banner: {
    background: 'linear-gradient(135deg, #060d3a 0%, #0d1a6e 50%, #1a1060 100%)',
    borderRadius: 18, marginBottom: 28, overflow: 'hidden',
    padding: '32px 36px', position: 'relative',
    boxShadow: '0 8px 32px rgba(6,13,58,0.25)',
  },
  bannerBg: {
    position: 'absolute', inset: 0,
    background: 'radial-gradient(ellipse at 80% 50%, rgba(79,110,247,0.2) 0%, transparent 60%)',
  },
  bannerBlob1: { position: 'absolute', width: 200, height: 200, borderRadius: '50%', background: 'rgba(79,110,247,0.1)', top: -80, right: 60, filter: 'blur(30px)' },
  bannerBlob2: { position: 'absolute', width: 120, height: 120, borderRadius: '50%', background: 'rgba(247,213,6,0.06)', bottom: -40, right: 200, filter: 'blur(20px)' },
  bannerGreet: { color: '#fff', fontSize: 24, fontWeight: 800, marginBottom: 8, letterSpacing: -0.3 },
  bannerSub: { color: 'rgba(255,255,255,0.6)', fontSize: 14 },
  statsRow: { display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 28 },
  statCard: {
    borderRadius: 16, padding: '22px 26px', minWidth: 160, flex: 1,
    position: 'relative', overflow: 'hidden', cursor: 'pointer',
  },
  statIconWrap: { fontSize: 22, marginBottom: 12, opacity: 0.9 },
  statValue: { fontSize: 38, fontWeight: 900, color: '#fff', lineHeight: 1, letterSpacing: -1 },
  statLabel: { fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.7)', marginTop: 8, letterSpacing: 1, textTransform: 'uppercase' },
  statArrow: { position: 'absolute', top: 18, right: 18, color: 'rgba(255,255,255,0.4)', fontSize: 18, fontWeight: 700 },
  empty: { color: '#94a3b8', fontSize: 14, padding: '20px 0' },
};

export default UserDashboard;
